import { FiBook, FiCloud, FiHome } from "react-icons/fi";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import styles from "./App.module.scss";
import { Navbar } from "./components/navbar/Navbar";
import { logAppEvent } from "./modules/firebase";
import { Assets } from "./pages/assets/Assets";
import { Blog } from "./pages/blog/Blog";
import { VirtualCamera } from "./pages/blogPosts/VirtualCamera";
import { Home } from "./pages/home/Home";

logAppEvent("visit");

export const routes = [
  {
    path: "/",
    element: <Home />,
    icon: <FiHome />,
    name: "Home",
    rootPath: true,
  },
  {
    path: "/blog",
    element: <Blog />,
    icon: <FiBook />,
    name: "Blog",
    rootPath: true,
  },
  {
    path: "/virtual-camera-with-javascript-ffi",
    element: <VirtualCamera />,
  },
  {
    path: "/assets",
    element: <Assets />,
    icon: <FiCloud />,
    name: "Assets",
    rootPath: true,
  },
];

function App() {
  return (
    <BrowserRouter>
      <div className={styles.app}>
        <Navbar />
        <div className={styles.container}>
          <Routes>
            {routes.map((route, index) => (
              <Route path={route.path} element={route.element} key={index} />
            ))}
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
